import { useEffect, useRef } from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import type { DotLottie } from '@lottiefiles/dotlottie-react'

type Props = {
    faceType: 'smile' | 'sad'
}

const FACE_SRC: Record<Props['faceType'], string> = {
    smile: '/assets/referrals/smile_face.lottie',
    sad: '/assets/referrals/sad_face.lottie',
} as const

const REPEAT_DELAY_MS = 1000

export const Face = ({ faceType }: Props) => {
    const repeatTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const cleanupRef = useRef<(() => void) | null>(null)

    const handleDotLottieRef = (dotLottie: DotLottie | null) => {
        if (repeatTimeoutRef.current) {
            clearTimeout(repeatTimeoutRef.current)
            repeatTimeoutRef.current = null
        }
        cleanupRef.current?.()
        cleanupRef.current = null

        if (!dotLottie) return

        const scheduleNextPlay = () => {
            repeatTimeoutRef.current = setTimeout(() => {
                dotLottie.play()
                repeatTimeoutRef.current = null
            }, REPEAT_DELAY_MS)
        }
        dotLottie.addEventListener('complete', scheduleNextPlay)
        cleanupRef.current = () => {
            dotLottie.removeEventListener('complete', scheduleNextPlay)
        }
    }

    useEffect(() => {
        return () => {
            if (repeatTimeoutRef.current) {
                clearTimeout(repeatTimeoutRef.current)
            }
            cleanupRef.current?.()
        }
    }, [])

    return (
        <DotLottieReact
            src={FACE_SRC[faceType]}
            dotLottieRefCallback={handleDotLottieRef}
            autoplay
        />
    )
}